/* eslint-disable no-dupe-keys */
export default {
  tag: {
    name: '标签',
    // 属性（一般与对象内容匹配）
    prop: {
      name: '标签名',
      tagged_count: '数量',
      category: '标签类型',
      color: '颜色',
      app_visible: 'APP可视',
      note: '备注',
      created_at: '创建时间',
      updated_at: '更新时间'
    },
    // Enum的属性
    // Boolean的属性
    app_visibles: { true: '可视', false: '不可视' },
    categories: {
      User: '用户标签',
      Product: '商品标签',
      StationComment: '评论标签'
    },
    sorting_positions: {
      before: '排在前面',
      after: '排在后面'
    },
    // 占位提示
    placeholder: {
      search_keyword: '查询标签名',
      input_note: 'APP用户不可见',
      select_ref_sorting_tag: '请选择对标的标签',
      select_tags: '选择标签',
      new_tag: '新建标签'
    },
    // 详情页标签
    // 标签标题
    list_tabs: {
      users: '用户标签',
      products: '商品标签',
      station_comments: '评论标签'
    },
    // 标题
    titles: {
      sorting: '标签排序'
    },
    labels: {
      sorting_position: '排序方式',
      ref_tag_id: '参考的标签'
    }
  }
}
